<template>
  <el-dialog
    :close-on-click-modal="false"
    title="账户列表"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="800px"
  >
    <section class="tableBox">
      <el-table
        ref="multipleTable"
        :data="originData.listData"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :sortable="item.sortable"
          :filters="item.filters"
          :filter-method="item.filterHandler"
          :min-width="item.minW"
          :width="item.w"
        />
      </el-table>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogFormVisible: false,
      originData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'custName',
            label: '账户姓名',
          },
          {
            prop: 'acctNo',
            label: '银行账号',
          },
          {
            prop: 'receBankBalance',
            label: '收款私户(元)',
          },
          {
            prop: 'payBankBalance',
            label: '付款私户(元)',
          },
          {
            prop: 'payUnDoBalance',
            label: '已付未提现(元)',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
    },
  },
};
</script>

<style>
</style>
